<template>
  <div class="tarjeta">
    <div class="container-logo">
      <v-img :src="logo" width="42px"></v-img>
    </div>
    <div class="container-titulo">
      <span>{{ titulo }}</span>
    </div>
    <div class="departamento">
      <v-icon size="x-large" color="676767">mdi-account-details</v-icon>
      <span><b>{{ departamento }}</b></span>
      <br>
      <v-icon size="x-large" color="676767" v-if="estado === 'Pendiente'">mdi-email</v-icon>
      <v-icon size="x-large" color="676767" v-if="estado === 'Respondida'">mdi-email-check</v-icon>
      <v-icon size="x-large" color="676767" v-if="estado === 'Cerrada'">mdi-email-lock</v-icon>
      <span>{{ estado }}</span>
    </div>
    <div @click="goDetail" class="tarjeta-selection">
        <v-icon color="black">mdi-chevron-right</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fecha: null,
      hora: null
    }
  },
  props: {
    autor: null,
    createdAt: null,
    clubId: null,
    partidoDescription: null,
    partidoId: null,
    departamento: null,
    estado: null,
    detailId: null,
    reportType: null,
    cardType: null,
    modified: null,
    titulo: null,
    logo: null
  },
  methods: {
    goDetail () {
      const consultaId = this.detailId
      this.$emit('goDetailConsultaPartido', consultaId)
    }
  },
  created () {

  }
}
</script>

<style scoped>
.tarjeta{
  background-color: #eeeeee;
  width: 90%;
  height: 70px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  flex-direction: row;
  overflow: hidden;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  margin: 20px auto;
}

.container-logo{
  display: flex;
  margin-left: 20px;
}

.autor-name{
  margin-left: 6px;
  align-self: center;
}

.departamento{
  margin-left: auto;
  margin-right: 10px;
  max-width: 200px;
  text-align: end;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

span{
  font-size: 1.2em;
  color: #293968;
}

.container-titulo{
  max-width: 400px;
  margin-left: 15px;

}

.tarjeta-selection{
  margin-right: 10px;
  cursor: pointer;
}

</style>
